import { Environment } from "./service/globalTypes";

export const CONFIG = {
  BUILD_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT as Environment,
  VERSION: process.env.VERSION,
};

export enum LocalStorageKeys {
  TOKEN = "token",
  ENVIRONMENT = "environment",
}

export enum SentryCustomData {
  ENVIRONMENT = "Environment",
  AUTO_UPDATE_ENABLED = "Auto Update enabled",
  CONNECTION_ESTABLISHED = "Connection established",
}
